export default __webpack_public_path__ + "static/media/svg-4.0bd0cf47.svg";